import axios from "axios";
import { WEB_ROUTE, REQUESTS } from "./apiConfig";

const API_ROUTES = {
  createAPIKey: "organisation/apikey/generate_key/",
  regenerateAPIKey: "organisation/apikey/regenerate_key/",
  deleteAPIKey: "organisation/apikey/delete_key/",
  fetchAPIKey: "organisation/apikey/"
};

export const createAPIKeyRequest = () => {
  return REQUESTS.post(API_ROUTES.createAPIKey, localStorage.getItem("token"));
};

export const regenerateAPIKeyRequest = () => {
  return REQUESTS.post(API_ROUTES.regenerateAPIKey, localStorage.getItem("token"));
};

export const deleteAPIKeyRequest = () => {
  return REQUESTS.delete(API_ROUTES.deleteAPIKey, localStorage.getItem("token"));
};

export const fetchAPIKeyRequest = () => {
  return REQUESTS.get(API_ROUTES.fetchAPIKey, localStorage.getItem("token"));
};

